import { z } from "zod"

import { trimmedStringSchema } from "./string.schema"

/** URLs routinely exceed `defaultMaxLength`. */
export const urlSchema = trimmedStringSchema
  .min(1)
  .pipe(z.url({ protocol: /^https?$/ }))
